import axios from "axios";
import { AUTH_SAME_ORIGIN_API_BASE } from "@/constants";
import { ApiResponse } from "@/types";

/**
 * Browser axios → same-origin `/api` (Vite proxy → Worker `/v3`).
 * Must not import or assert AUTH_ORIGIN / INTERNAL_API_URL / secrets.
 */
export const axiosInstance = axios.create({
  baseURL: AUTH_SAME_ORIGIN_API_BASE,
  withCredentials: true,
  timeout: 100_000,
  headers: { "X-Vetty-Fingerprint": Date.now() },
});

export const handleAxiosError = (error: unknown): ApiResponse | null => {
  if (axios.isAxiosError(error)) {
    if (error.response) {
      // Do not log response bodies (may include tokens / PII).
      return error.response.data;
    }
    return null;
  }
  return null;
};

/** Safe user-facing message; never forward raw upstream bodies to toasts/UI blindly. */
export const genericAuthRequestErrorMessage = "Something went wrong. Try again.";
